<template>
  <el-popover
    placement="bottom-start"
    trigger="hover"
  >
    <div class="feet">
      <!--下载模板-->
      <el-button type="primary" size="small" @click="onDownloadTemplate">{{ $t('basicData.DownloadTheTemplate') }}</el-button>

      <!--批量导入-->
      <upload-excel
        v-permit:remove="'btn:payable:quoteManagement:addEdit'"
        class="feet-btn"
        :on-success="importLogistics"
        :but-name="$t('basicData.BulkImport')"
      />

      <!--下载报价-->
      <el-button type="primary" size="small" @click="downloadOffer">{{ $t('basicData.DownloadTheQuote') }}</el-button>
    </div>
    <!--导入/下载-->
    <template #reference>
      <el-button
        size="small"
        plain
      >{{ $t('basicData.ImportDownload') }}</el-button>
    </template>
  </el-popover>
</template>

<script>
import { downloadTemplate, importTemplate, downloadQuotation } from './utils';

export default {
  components: {
    'upload-excel': () => import('@/components/UploadExcel/index.vue')
  },

  props: {
    // 业务类型
    businessType: {
      type: [String, Number],
      default: ''
    },
    // 所有分区
    subregionList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 车线
    stitchingLine: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 下载模板需要的回调函数
    getDataFunc: {
      type: Function,
      required: true
    },
    // 特殊费用
    feeList: {
      type: Array,
      default: () => [],
      required: true
    }

  },

  methods: {
    getData() {
      return this.businessType === 5 ? this.stitchingLine : this.subregionList;
    },
    // 下载模板
    onDownloadTemplate() {
      // 运输业务选择车线
      const list = this.getData();
      downloadTemplate(list, this.feeList, this.businessType);
    },

    // 批量导入报价
    importLogistics(fileData) {
      console.log(fileData, 'xlsx');
      try {
        const list = this.getData();
        const arr = importTemplate(list, fileData);
        arr.forEach(item => {
          item.specialRules = this.feeList.find(fee => fee.code === item.feeTypeCode)?.specialRules || '';
        });
        this.$emit('importList', arr);
      } catch (error) {
        this.$message.warning(this.$t('orderCenterCont.ImportFailed'));
        console.error(error);
      }
    },

    // 下载报价
    downloadOffer() {
      const data = this.getDataFunc();
      const list = this.getData();
      downloadQuotation(list, this.feeList, this.businessType, data);
    }
  }

};
</script>
